<template>
    <el-dialog
        class="contract_finish-dialog"
        destroy-on-close
        show-close
        :visible.sync="visible"
        :title="translate('title')"
    >
        <div class="contract_finish-dialog__content">
            <h3>
                {{
                    translate('subtitle', {
                        client: data.contract_data.client_name
                    })
                }}
            </h3>
            <el-alert type="warning" :closable="false">
                <template #default>
                    <el-icon name="warning" />
                    {{
                        translate('tip', {
                            client: data.contract_data.client_name
                        })
                    }}
                </template>
            </el-alert>
            <h3>{{ translate('contract_data_title') }}</h3>
            <el-card>
                <div class="contract_finish-dialog__content__info">
                    <p>
                        {{ translate('contract_number') }}:
                        <strong>{{
                            data.contract_data.contract_number
                        }}</strong>
                    </p>
                    <p>
                        {{ translate('contract_volume') }}:
                        <strong>{{ data.contract_data.volume }}</strong>
                    </p>
                    <p>
                        {{ translate('cultivation') }}:
                        <strong>{{ data.contract_data.cultivation_id }}</strong>
                    </p>
                    <p>
                        {{ translate('client') }}:
                        <strong>{{ data.contract_data.client_name }}</strong>
                    </p>
                </div>
            </el-card>
            <h3>{{ translate('properties') }}</h3>
            <el-card>
                <p>
                    {{ translate('properties_total') }}:
                    <strong>{{ data.properties.length }}</strong>
                </p>
            </el-card>
            <h3>
                {{
                    translate('message', {
                        client: data.contract_data.client_name
                    })
                }}
            </h3>
        </div>
        <div class="contract_finish-dialog__actions">
            <el-button @click="visible = false" size="small" :loading="loading">
                {{ $t('contrato_rastreabilidade.words.close') }}
            </el-button>
            <el-button
                type="primary"
                @click="send"
                size="small"
                :loading="loading"
            >
                {{ translate('confirm') }}
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'DialogContractFinish',
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false
        };
    },
    computed: {
        ...mapState('traceabilityContractModule', {
            data: 'form'
        }),
        visible: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        ...mapActions('traceabilityContractModule', [
            'createTraceabilityReport',
            'updateTraceabilityReport',
            'fetchTraceabilityReports'
        ]),
        translate(key, params = {}) {
            const base =
                'contrato_rastreabilidade.messages.contract_finish_dialog';
            return this.$t(`${base}.${key}`, params);
        },
        async send() {
            try {
                this.loading = true;
                this.data.status = 'ENVIADO';
                if (this.data.id) {
                    await this.updateTraceabilityReport(this.data);
                } else {
                    await this.createTraceabilityReport(this.data);
                }
                this.$emit('onSent');
                this.$notify.success(this.translate('sent_successfully'));
                this.$store.commit('traceabilityContractModule/SET_FILTER', {
                    page: 0
                });
                this.visible = false;
            } catch (error) {
                this.$notify.error(this.translate('sent_error'));
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.contract_finish-dialog {
    h3 {
        font-size: 14px;
        font-weight: 400;
        color: #3b3b3b;
    }

    .contract_finish-dialog__content {
        display: grid;
        grid-template-columns: 1fr;
        gap: 18px;
        word-break: break-word;
    }

    .contract_finish-dialog__actions {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }
}
</style>
